"use strict";
exports.__esModule = true;
exports.CREDIT_REPORT = void 0;
var CREDIT_REPORT = {
    SCORE_RESULT: {
        PASSED: 'PASSED',
        WARNING: 'WARNING',
        FAILED: 'FAILED'
    },
    SCORE_CARD_NAME: {
        ADVRS: 'ADVRS',
        CLNDP: 'CLNDP',
        CLNSH: 'CLNSH',
        CLN1A: 'CLN1A',
        CTS1A: 'CTS1A',
        CTSSH: 'CTSSH',
        CTSDP: 'CTSDP',
        CTSAD: 'CTSAD',
        INSLV: 'INSLV'
    }
};
exports.CREDIT_REPORT = CREDIT_REPORT;
